import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/Login.vue'
import MainBox from '../views/MainBox.vue'
import RoutesConfig from './config'
import store from '../store/index';
import Home from '../views/UserPage/home.vue'
import msgbox from '../views/UserPage/msg/msgbox.vue'
import NotFound from '../views/notfound/NotFound.vue'

import Songlist from '../views/UserPage/songlist.vue'
import LiveCalendar from '../views/UserPage/LiveCalendar.vue'
import About from '../views/UserPage/About.vue'
import Works from '../views/UserPage/Works.vue'
import Points from '../views/UserPage/Points.vue'
import Captain from '../views/UserPage/Captain.vue'
import UserLogin from '../views/UserPage/userlogin.vue'
import ExchangeRecord from '../views/UserPage/ExchangeRecord.vue'
const routes = [
  {
    path: "/admin/login",
    name: "login",
    component: Login
  },
  {
    path: "/user/login",
    name: "UserLogin",
    component: UserLogin
  },
  {
    path: "/mainbox",
    name: "mainbox",
    component: MainBox,
  },
  //
  {
    path: "/index",
    name: "Home",
    component: Home
  },

  {
    path: "/",
    name: "Home",
    component: Home
  },

  {
    path: "/admin",
    redirect: "/admin/login"
  },
  //作品预览，投稿内容展示
  {
    path: "/works",
    name: "Works",
    component: Works
  },
  //积分兑换
  {
    path: "/points",
    name: "Points",
    component: Points
  },
  //礼物查看，舰长/提督/总督信息地址填写地址跳转
  {
    path: "/captain",
    name: "Captain",
    component: Captain
  },
  //歌单
  {
    path: "/songlist",
    name: "Songlist",
    component: Songlist
  },
  //直播日历（在「歌单」和「关于」之间）
  {
    path: "/livecalendar",
    name: "LiveCalendar",
    component: LiveCalendar
  },
  //关于，联系我们
  {
    path: "/about",
    name: "About",
    component: About
  },
  //兑换记录
  {
    path: "/exchange-records",
    name: "ExchangeRecord",
    component: ExchangeRecord
  },

  {
    path: "/msgbox/message/:pathMatch(.*)*",
    component: msgbox
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 后台路由的准入判断：必须同时有登录 token 与管理员身份。
// 说明：真正的权限边界在服务端（所有 /adminapi/ 管理接口都校验管理员 token），
// 这里只负责「没登录就不要把后台骨架渲染出来」。
const isAdminArea = (path) => path === '/admin' || path.startsWith('/admin/')
const isAdminPage = (path) => isAdminArea(path) && path !== '/admin/login'
// 能不能进后台区域：有 token + 有角色 + 这个角色至少有一个能看的页面
// （以前这里写死 role === 'admin'，害得「运营 / 客服」这种自定义权限等级一律被弹回登录页）
const canEnterAdmin = () => {
  if (!localStorage.getItem('token')) return false
  const info = store.state.userInfo || {}
  if (!info.role) return false
  if (info.role === 'admin' || Number(info.isSuper) === 1) return true
  if (info.pages === undefined) return true          // 改版前登录的旧会话
  return Array.isArray(info.pages) && info.pages.length > 0
}

router.beforeEach((to, from, next) => {
  // 后台区域准入（原来这里判的是 to.name === "Login"，而登录路由名是小写 login，分支永远不成立）
  if (isAdminPage(to.path) && !canEnterAdmin()) {
    next({ path: '/admin/login' })
    return
  }

  if (to.name === "Login" || to.name === "UserLogin") {
    next();
    return;
  }

  if (!store.state.isGetterRouter) {
    ConfigRouter();
    next({ path: to.fullPath });
  } else {
    next();
  }
});

const ConfigRouter = () => {
  if (!router.hasRoute("mainbox")) {
    router.addRoute(
      {
        path: "/mainbox",
        name: "mainbox",
        component: MainBox,
        children: RoutesConfig
      },
    )
  }
  RoutesConfig.forEach(item => {
    checkPermission(item) && router.addRoute("mainbox", item)
  })
  //修改isGetterRouter为true
  store.commit("changeGetterRouter", true)
}

/**
 * 单个后台路由的准入判断。
 * role 在数据库里是 varchar，实际值是 'admin'，所以不能和数字比较（原来写的是 === 1，恒为 false）。
 */
const checkPermission = (item) => {
  const info = store.state.userInfo || {}
  // 还没登录 / 没角色 → 后台路由一律不给挂
  if (!info.role) return false
  // 超级管理员：全给（含用户管理、权限管理）
  if (info.role === 'admin' || Number(info.isSuper) === 1) return true
  // 改版前登录的旧会话没有 pages 字段，按全给处理，免得把主人锁在门外（下次登录就会带上了）
  if (info.pages === undefined) return true
  // 其它等级：按「权限管理」里勾选的页面清单放行（key 就是路由路径）
  const pages = Array.isArray(info.pages) ? info.pages : []
  return pages.indexOf(item.path) >= 0
}


export default router
